import api from '../../../api/index';
import shopkeeperAppApi from '../../../api/shopkeeperAppApi';

export default {
  updateSenhaBalconista({ rootGetters }, value) {
    return api.post('atualizar-senha-balconista', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  buscarCliente({ rootGetters }, data) {
    return shopkeeperAppApi.post('balconista/buscar-cliente', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  buscarOrcamento({ rootGetters }, id) {
    return shopkeeperAppApi.get('balconista/buscar-orcamento-site/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  contOrcamento({ rootGetters }, id) {
    return shopkeeperAppApi.get('balconista/qtd-orcamento-site/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  salvarCliente({ rootGetters }, data) {
    return shopkeeperAppApi.post('balconista/salvar-cliente', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  buscarProduto({ }, data) {
    return shopkeeperAppApi.post(`balconista/listar-produtos`, data, {cancelToken: data.cancelToken});
  },
  finalizarOrcamento({ rootGetters }, data) {
    return shopkeeperAppApi.post('balconista/salvar-orcamento', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateDadosBalconista({ rootGetters, commit }, value) {
    return api.post('atualizar-dados-balconista', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    })
    .then((response) => {
      commit('setDadosUsuario', response.data.dados);
      localStorage.setItem('dadosUsuario', JSON.stringify(response.data.dados));
    })
  },

  solicitarSaqueBalconista({ rootGetters }, data) {
    return api.post('solicitar-saque', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    })
  },
  puxarCoins({ rootGetters }, id) {
    return api.get(`get-coins/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    })
  },
  alterarStatus({ rootGetters }, data) {
    return api.post('alter-status', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    })
  },
  realizarPagamento({ }, data) {
    return shopkeeperAppApi.post('balconista/realizar-pagamento-balconista', data,)
  },
  puxarLog({ rootGetters }, id) {
    return api.get(`push-log/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    })
  },
  getAllLog({ rootGetters }, currentPage) {
    return api.get(`get-all-log?page=${currentPage || 1}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    })
  },
  getPermissionClerk({ rootGetters }, id) {
    return api.get(`permissao-balconista/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getDataClerk({rootGetters}, construpUserId){
    return api.get(`dados-balconista/${construpUserId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updatePermissionClerk({rootGetters}, data){
    return api.post('criar-permissao-balconista', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  verifyCoupon({ }, data) {
    return shopkeeperAppApi.post('discount-coupon/validate', data,)
  },
};